import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import pt from 'vuetify/lib/locale/pt' // importar a tradução para português

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
      locales: { pt }, // definir a tradução como padrão
      current: 'pt' // definir o idioma atual
    },
    theme: {
      themes: {
        light: {
          primary: '#546E7A'
        },
      },
    },
});
